module.exports = __webpack_public_path__ + "img/book_05.bec1646e.jpg";